export enum AccessMode {
  YSY = 1,
  HK = 2,
  RTSP = 3,
}

export enum ConfigType {
  ORIGIN = 1,
  PROXY,
}
